import { FC } from "react";
import TemplateSvg from "../../public/icons/Template.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const TemplateIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><TemplateSvg/></span>;
